import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import SurfaceCanvas from '~/components2/Map/canvas/Surface';
import { mapState } from '~/components2/Map/Map';
import store from './store';

interface SurfaceProps {
  interactive?: boolean;
}

export default function Surface({ interactive = true }: SurfaceProps) {
  const map = useMap();
  const { objectsAsArray } = useSnapshot(store) as typeof store;
  const containerDiv = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (containerDiv.current && map.current) {
      const surface = new SurfaceCanvas({
        id: `main-surface-${nanoid()}`,
        container: containerDiv.current,
        map: map.current.getMap(),
        store: store,
      });

      if (interactive === false) {
        surface.objects.forEach((o) => {
          o.interactive = false;
        });
      }

      const unsubscribe = subscribe(mapState, () => {
        surface.refreshScreenCoords();
      });

      return () => {
        unsubscribe();
        surface.destroy();
      };
    }
  }, []);

  const isVisible = objectsAsArray.length > 0;

  if (!map.current) {
    return null;
  }

  return (
    <div
      id="home-map-surface"
      style={{ cursor: '-moz-grab' }}
      className={`absolute left-0 top-0 ${isVisible ? 'visible' : 'hidden'}`}
      ref={containerDiv}
    ></div>
  );
}
